<template>
  <div class="code">
    <Head title="更换手机号"></Head>
    <div class="code_content">
      <div
        style="
          font-size: 23px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-top: 100px;
          margin-left: 30px;
        "
      >
        输入验证码
      </div>
      <div
        style="
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-left: 30px;
          margin-top: 9px;
        "
      >
        {{ phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") }}
      </div>
      <div style="margin-top: 30px; padding: 0px 20px 0px 14px">
        <van-form>
          <van-field
            class="input_code"
            v-model="code"
            type="number"
            placeholder="请填写验证码"
            maxlength="6"
          >
            <span
              @click="getCode"
              slot="right-icon"
              :class="['tel_code', keyFlag ? '' : 'fontColor']"
              >{{ keyFlag ? "获取验证码" : num + "秒后重新获取" }}</span
            >
          </van-field>
        </van-form>
      </div>
    </div>
    <div class="exit">
      <van-button class="bot" @click="setLoing">下一步</van-button>
    </div>
  </div>
</template>

<script>
import Head from "../components/headTabs.vue";
import { Toast } from "vant";
export default {
  name: "code",
  components: {
    Head,
  },
  data() {
    return {
      phone: "",
      code: "", //验证码
      num: 2,
      keyFlag: true,
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
    this.keyFlagChange();
  },
  methods: {
    // 获取验证码
    async getCode() {
      if (!this.keyFlag) return;
      const res = await this.$apis.loginServe.getCode({
        phone: this.phone,
        adapter: "change_bind",
      });
      if (res.resultCode == "200") {
        Toast("获取成功");
        this.keyFlagChange();
      } else {
        Toast(res.resultDesc);
      }
    },
    // 获取验证码时间
    keyFlagChange() {
      this.keyFlag = false;
      let timer = setInterval(() => {
        if (this.num <= 0) {
          clearInterval(timer);
          this.keyFlag = true;
          this.num = 59;
        } else {
          this.num = --this.num;
        }
      }, 1000);
    },
    // 点击下一步
    async setLoing() {
      if (this.code) {
        const res = await this.$apis.loginServe.validateCode({
          phone: this.phone,
          randomCode: this.code,
        });
        if (res.resultCode === "200") {
          this.$router.push({
            path: "/setpassword",
            query: { phone: this.phone, code: this.code },
          });
        } else {
          Toast(res.resultDesc);
        }
      } else {
        Toast("请输入验证码");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.code {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #fff;
  .code_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 100px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      margin: 0 auto;
    }
  }
  .code_content {
    width: 94%;
    height: 100%;
    margin: 0 auto;
  }
  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 22px;
    .bot {
      width: 84%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      background: #4a79f1;
    }
  }
}
</style>
